// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"56":"route.categories","109":"route.settings","672":"route.leadership","743":"route.location","863":"route.subcategories"}[chunkId] + "." + {"56":"24404b0b","109":"1516627b","672":"1b3e08ec","743":"cd9df735","863":"88b59574"}[chunkId] + ".chunk.js";
};